export const barchartI18NPl = {
    noData: "Brak danych",
};
